import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { Router } from '@angular/router';
import { Settings } from '../../../app.settings.model';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit, AfterViewInit {

  public settings: Settings;

  constructor(public appSettings: AppSettings, public router: Router) {
    this.settings = this.appSettings.settings; 
  }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.settings.loadingSpinner = false;  
  } 
  
  public goHome(): void {
    this.router.navigate(['/']);
  }

}
